/**
 * Returns a callback to open/close one of the components by index.
 * @param {Element[]|jQuery} components
 * @param {number} index
 * @returns {Function} A callback function
 */
const handleToggleByIndex = (components, index = null) => () => {
    $(components).attr('data-active', false);

    if (index !== null) {
        $(components).eq(index).attr('data-active', true);
    }
};

export default handleToggleByIndex;



// WEBPACK FOOTER //
// ./src/scripts/components/common/handleToggleByIndex.js